export default "__VITE_ASSET__XBsLztDN__"